import axios from 'axios';
// import moment from 'moment';

import {
    GET_TOURS,
    GET_TOUR,
    BOOK_TOUR,
    GET_PAYMENT_INFO_TOUR,
    GET_ERRORS,
    SET_LOADING,
    SAVE_USER_BOOKING,
    CLEAR_ERRORS
} from './types';

import { API_ENDPOINT } from '../config/constants';

export const getTours = () => dispatch => {
    dispatch(setLoading());

    axios.get(API_ENDPOINT+'/tours')
        .then(res =>{
            dispatch({
                type: GET_TOURS,
                payload: res.data.tours
            });

            // setTimeout(() => {
            //     for (let i=0; i<res.data.tours.length; i++) {
            //         let actualTour = res.data.tours[i];
            //         if (!!actualTour.bookings && actualTour.bookings.length>0) {
            //             for (let j=0; j<actualTour.bookings.length; j++) {
            //                 let actualBooking = actualTour.bookings[j];
            //                 if (moment(actualBooking.start).isAfter(moment())) {
            //                     console.log("TOUR: ", actualTour.name);
            //                     console.log(moment(actualBooking.start).format("DD/MM/YYYY"), " a ", moment(actualBooking.end).format("DD/MM/YYYY"));
            //                 }
            //             }
            //         } else {
            //             if (!!actualTour.bookings) console.log("actualTour.bookings.length: ", actualTour.bookings.length);
            //             console.error("Problema recorriendo los bookings del Tour ", actualTour.name);
            //         }
            //     }
            // }, 3000);
        })
        .catch(err => {
            console.log(err);
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        });
};

export const getTour = id => dispatch => {
    dispatch(setLoading());

    axios.get(API_ENDPOINT+`/tours/${id}`)
        .then(res =>
            dispatch({
                type: GET_TOUR,
                payload: res.data.tour
            })
        )
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const bookTour = bookingInfo => dispatch => {
    dispatch(clearErrors());

    axios.post(API_ENDPOINT+`/booking/tours/${bookingInfo.tourId}`, bookingInfo)
        .then(res => {
            dispatch({
                type: BOOK_TOUR,
                payload: res.data.booked
            });

            let bookingIds = { booked: res.data.booked };

            axios.post(API_ENDPOINT+`/booking/tours/${bookingInfo.tourId}/create-payment`, bookingIds)
                .then(resP => {
                    dispatch({
                        type: GET_PAYMENT_INFO_TOUR,
                        payload: resP.data.payment_info
                    });

                    localStorage.setItem('BOOKING_IDS', JSON.stringify(res.data));
                    localStorage.setItem('PAYMENT_INFO', JSON.stringify(resP.data.payment_info));
                })
                .catch(err =>
                    dispatch({
                        type: GET_ERRORS,
                        payload: err.response.data
                    })
                );
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const saveUserBooking = userInfo => dispatch => {
    dispatch(clearErrors());

    axios.put(API_ENDPOINT+`/tourist/${userInfo._id}`, userInfo)
        .then(res =>
            dispatch({
                type: SAVE_USER_BOOKING,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const setLoading = () => {
    return {
        type: SET_LOADING
    }
};

/**
 * TODO: Revisar el aspecto de mostrar/limpiar errores de formulario
 */

export const clearErrors = () => {
    return {
        type: CLEAR_ERRORS
    }
};


// WEBPACK FOOTER //
// ./src/actions/toursActions.js